export const referred = 'referred';
export const lblProductPickupTITLEDEFAULTNOSTORE = 'lbl_Product_pickup_TITLE_DEFAULT_NOSTORE';
export const lblProductPickupPRODUCTBOPIS = 'lbl_Product_pickup_PRODUCT_BOPIS';
export const lblProductPickupBOPISAVAILABLE = 'lbl_Product_pickup_BOPIS_AVAILABLE';
export const lblProductPickupBOPISONLYAVAILABLE = 'lbl_Product_pickup_BOPIS_ONLY_AVAILABLE';
export const lblProductPickupBOSSAVAILABLE = 'lbl_Product_pickup_BOSS_AVAILABLE';
export const lblProductPickupBOSSONLYAVAILABLE = 'lbl_Product_pickup_BOSS_ONLY_AVAILABLE';
export const lblProductPickupPICKUPINSTORE = 'lbl_Product_pickup_PICKUP_IN_STORE';
export const lblProductPickupSPACEONE = 'lbl_Product_pickup_SPACE_ONE';
export const lblProductPickupFREESHIPPING = 'lbl_Product_pickup_FREE_SHIPPING';
export const lblProductPickupNOMINPURCHASE = 'lbl_Product_pickup_NO_MIN_PURCHASE';
export const lblProductPickupFINDSTORE = 'lbl_Product_pickup_FIND_STORE';
export const lblProductPickupBOPISDISABLEDFITSSLIM = 'lbl_Product_pickup_BOPIS_DISABLED_FITS_SLIM';
export const lblProductPickupBOPISDISABLEDFITSHUSKY =
  'lbl_Product_pickup_BOPIS_DISABLED_FITS_HUSKY';
export const lblProductPickupBOPISDISABLEDFITSPLUS = 'lbl_Product_pickup_BOPIS_DISABLED_FITS_PLUS';
export const lblProductPickupCHANGESTORE = 'lbl_Product_pickup_CHANGE_STORE';
export const lblProductPickupSHIPPINGMETHODTITLE = 'lbl_Product_pickup_SHIPPING_METHOD_TITLE';
export const lblProductPickupSHIPITICONNAME = 'lbl_Product_pickup_SHIP_IT_ICON_NAME';
export const lblProductPickupPICKITUPICONNAME = 'lbl_Product_pickup_PICK_IT_UP_ICON_NAME';
export const lblProductPickupPICKITUPFIRSTTEXT = 'lbl_Product_pickup_PICK_IT_UP_FIRST_TEXT';
export const lblProductPickupPICKITUPSECONDTEXT = 'lbl_Product_pickup_PICK_IT_UP_SECOND_TEXT';
export const lblProductPickupFREESHIPPINGRedesign = 'lbl_Product_pickup_FREE_SHIPPING_redesign';
export const lblProductPickupNOMINPURCHASERedesign = 'lbl_Product_pickup_NO_MIN_PURCHASE_redesign';
export const lblProductPickupPICKUPINSTORERedesign = 'lbl_Product_pickup_PICKUP_IN_STORE_redesign';
export const lblProductPickupFINDSTORERedesign = 'lbl_Product_pickup_FIND_STORE_redesign';
export const lblProductPickupBOPISINTHESTORERedesign =
  'lbl_Product_pickup_BOPIS_IN_THE_STORE_redesign';
export const lblProductPickupCHANGESTORERedesign = 'lbl_Product_pickup_CHANGE_STORE_redesign';
export const lblProductPickupOUTOFSTOCKButtonRedesign =
  'lbl_Product_pickup_OUT_OF_STOCK_button_redesign';
export const lblProductPickupOUTOFSTOCKTEXTRedesign =
  'lbl_Product_pickup_OUT_OF_STOCK_TEXT_redesign';
export const lblProductPickupSELECTSIZEWARNINGTEXTRedesign =
  'lbl_Product_pickup_SELECT_SIZE_WARNING_TEXT_redesign';
export const lblProductPickupSHIPPING = 'lbl_Product_pickup_SHIPPING';
export const lblProductPickupPICKUP = 'lbl_Product_pickup_PICKUP';
export const lblProductPickupNORUSHPICKUP = 'lbl_Product_pickup_NO_RUSH_PICKUP';
export const lblProductPickupCHANGESTOREDM = 'lbl_Product_pickup_CHANGE_STORE_DM';
export const lblProductPickupPICKUPINSTEAD = 'lbl_Product_pickup_PICKUP_INSTEAD';
export const lblProductPickupSEARCHOTHERSTORES = 'lbl_Product_pickup_SEARCH_OTHER_STORES';
export const lblProductPickupPICKUPINSTOREDM = 'lbl_Product_pickup_PICKUP_IN_STORE_DM';
export const lblProductPickupEXTRANORUSHPICKUPOFFER =
  'lbl_Product_pickup_EXTRA_NO_RUSH_PICKUP_OFFER';
export const lblProductPickupGETITASAP = 'lbl_Product_pickup_GET_IT_ASAP';
export const lblProductPickupSHIPTOHOMEICONNAME = 'lbl_Product_pickup_SHIP_TO_HOME_ICON_NAME';
export const lblProductPickupSELECTSIZEPICKUPWARNINGTEXTRedesign =
  'lbl_Product_pickup_SELECT_SIZE_PICKUP_WARNING_TEXT_redesign';
export const lblProductPickupCLOSESIN = 'lbl_Product_pickup_CLOSES_IN';
export const lblProductPickupOPENUNTIL = 'lbl_Product_pickup_OPEN_UNTIL';
export const lblProductPickupOPENSTOMORROWAT = 'lbl_Product_pickup_OPENS_TOMORROW_AT';
export const lblProductPickupCLOSED = 'lbl_Product_pickup_CLOSED';
export const lblProductPickupSHOWITEM = 'lbl_Product_pickup_SHOW_ITEM';
export const lblProductPickupHIDEITEM = 'lbl_Product_pickup_HIDE_ITEM';
export const lblProductPickupBOSSNOTAVAILABLE = 'lbl_Product_pickup_BOSS_NOT_AVAILABLE';
export const lblProductPickupBOPISNOTAVAILABLE = 'lbl_Product_pickup_BOPIS_NOT_AVAILABLE';
export const lblProductPickupALLAVAILABLE = 'lbl_Product_pickup_ALL_AVAILABLE';
export const lblProductPickupPARTIALAVAILABLE = 'lbl_Product_pickup_PARTIAL_AVAILABLE';
export const lblProductPickupSELECTEDSTORE = 'lbl_Product_pickup_SELECTED_STORE';
export const lblFreePickupLocation = 'lbl_free_pickup_location';
export const lblStoresNearby = 'lbl_stores_nearby';
export const lblCheckOtherLocations = 'lbl_check_other_locations';
export const lblStoreUnavailableError = 'lbl_store_unavailable_error';
export const lblStoreUnavailableErrorBoss = 'lbl_store_unavailable_error_boss';

export const ProductPickupLabels = {
  [referred]: '',
  [lblProductPickupTITLEDEFAULTNOSTORE]: 'Select Store',
  [lblProductPickupPRODUCTBOPIS]: 'Buy online - Pick up in store',
  [lblProductPickupBOPISAVAILABLE]: 'Pick up TODAY!',
  [lblProductPickupBOPISONLYAVAILABLE]: 'Item available for pickup TODAY',
  [lblProductPickupBOSSAVAILABLE]: 'Or choose NO RUSH Pickup ',
  [lblProductPickupBOSSONLYAVAILABLE]: 'Choose NO RUSH Pickup ',
  [lblProductPickupPICKUPINSTORE]: 'PICK UP IN STORE',
  [lblProductPickupSPACEONE]: ' ',
  [lblProductPickupFREESHIPPING]: 'FREE Shipping Every Day!',
  [lblProductPickupNOMINPURCHASE]: 'No Minimum Purchase Required.',
  [lblProductPickupFINDSTORE]: 'Find in Store',
  [lblProductPickupBOPISDISABLEDFITSSLIM]: 'slim',
  [lblProductPickupBOPISDISABLEDFITSHUSKY]: 'husky',
  [lblProductPickupBOPISDISABLEDFITSPLUS]: 'plus',
  [lblProductPickupCHANGESTORE]: '(Change Store)',
  [lblProductPickupSHIPPINGMETHODTITLE]: 'Delivery Method',
  [lblProductPickupSHIPITICONNAME]: 'Ship it!',
  [lblProductPickupPICKITUPICONNAME]: 'Pick it up!',
  [lblProductPickupPICKITUPFIRSTTEXT]: 'Need it ASAP?',
  [lblProductPickupPICKITUPSECONDTEXT]: 'Get it today!',
  [lblProductPickupFREESHIPPINGRedesign]: 'Free shipping',
  [lblProductPickupNOMINPURCHASERedesign]: 'No minimum required',
  [lblProductPickupPICKUPINSTORERedesign]: 'Pick-up In Store',
  [lblProductPickupFINDSTORERedesign]: 'Find In Store',
  [lblProductPickupBOPISINTHESTORERedesign]: 'at this store',
  [lblProductPickupCHANGESTORERedesign]: 'Change',
  [lblProductPickupOUTOFSTOCKButtonRedesign]: 'Check Other Stores',
  [lblProductPickupOUTOFSTOCKTEXTRedesign]: 'Out of Stock',
  [lblProductPickupSELECTSIZEWARNINGTEXTRedesign]: 'Select a size to preview availability',
  [lblProductPickupSHIPPING]: 'Shipping',
  [lblProductPickupPICKUP]: 'Pickup',
  [lblProductPickupNORUSHPICKUP]: 'Ship to Store',
  [lblProductPickupCHANGESTOREDM]: 'Change Store',
  [lblProductPickupPICKUPINSTEAD]: 'Pickup Instead',
  [lblProductPickupSEARCHOTHERSTORES]: 'Search Other Stores',
  [lblProductPickupPICKUPINSTOREDM]: 'Pickup In Store',
  [lblProductPickupEXTRANORUSHPICKUPOFFER]: 'Extra 10% Off',
  [lblProductPickupGETITASAP]: 'Get it ASAP!',
  [lblProductPickupSHIPTOHOMEICONNAME]: 'Ship to Home',
  [lblProductPickupSELECTSIZEPICKUPWARNINGTEXTRedesign]: 'Select a size to preview pickup date',
  [lblProductPickupCLOSESIN]: 'Closes in',
  [lblProductPickupOPENUNTIL]: 'Open until',
  [lblProductPickupOPENSTOMORROWAT]: 'Opens tomorrow at',
  [lblProductPickupCLOSED]: 'Closed',
  [lblProductPickupSHOWITEM]: 'Show Item',
  [lblProductPickupHIDEITEM]: 'Hide Item',
  [lblProductPickupBOSSNOTAVAILABLE]: 'This store is currently unavailable for Ship To Store',
  [lblProductPickupBOPISNOTAVAILABLE]:
    'Sorry none of your selected items are available at this store',
  [lblProductPickupALLAVAILABLE]: 'All items available in this store',
  [lblProductPickupPARTIALAVAILABLE]:
    '#availableItemsCount of #totalItemsCount Items in this store',
  [lblProductPickupSELECTEDSTORE]: 'Selected Store',
  [lblFreePickupLocation]: 'Free Pickup at this location',
  [lblStoresNearby]: 'stores nearby',
  [lblCheckOtherLocations]: 'check other locations',
  [lblStoreUnavailableError]:
    'This size/color is not available for Pickup at stores nearby. Modify your selection or',
  [lblStoreUnavailableErrorBoss]: 'Ship to Store is unavailable at your favorite store.',
  lbl_Product_pickup_Get_it: 'Get it',
  lbl_Product_pickup_Free_Pick_Up: 'Free Pick Up',
};
